"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PayFabricPaymentsSDK;

var _react = _interopRequireWildcard(require("react"));

var _PayFabricPaymentsSDKModule = _interopRequireDefault(require("./PayFabricPaymentsSDK.module.css"));

var _paymentHelpers = require("./paymentHelpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PAYFABRIC_PAYMENTS_SDK_ID = 'payFabricPaymentsSDK';

function PayFabricPaymentsSDK(props) {
  var token = props.token,
      handleFormLoaded = props.handleFormLoaded,
      handleCancel = props.handleCancel,
      handleTransactionCompleted = props.handleTransactionCompleted,
      handleTransactionFailed = props.handleTransactionFailed,
      isProduction = props.isProduction;
  var loadPaymentsSDK = (0, _react.useCallback)(function () {
    try {
      var payFabricPaymentsSDK = document.getElementById(PAYFABRIC_PAYMENTS_SDK_ID);

      if (payFabricPaymentsSDK) {
        new payfabricpayments({
          environment: isProduction ? 'LIVE' : 'SANDBOX',
          target: PAYFABRIC_PAYMENTS_SDK_ID,
          session: token,
          successCallback: function successCallback(response) {
            if (handleTransactionCompleted instanceof Function) {
              handleTransactionCompleted(response);
            }
          },
          failureCallback: function failureCallback(response) {
            if (handleTransactionFailed instanceof Function && response.ResultCode === '0') {
              response.errorMessage = (0, _paymentHelpers.getErrorMessage)(response.RespStatus);
              handleTransactionFailed(response);
            }
          },
          cancelCallback: function cancelCallback() {
            if (handleCancel instanceof Function) handleCancel();
          },
          readyCallback: function readyCallback() {
            if (handleFormLoaded instanceof Function) handleFormLoaded();
          },
          displayMethod: 'IN_PLACE',
          requireShippingAddress: false,
          acceptedPaymentMethods: ['CreditCard', 'ApplePay', 'GooglePay'],
          themeName: 'VitusPayMobile'
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [handleCancel, handleFormLoaded, handleTransactionCompleted, handleTransactionFailed, isProduction, token]);

  _react.default.useEffect(function () {
    if (token) {
      var script = document.createElement('script');
      script.src = 'https://cdn.vitusvet.com/scripts/payfabricpayments.v2.bundle.min.js';
      script.onload = loadPaymentsSDK;
      document.head.appendChild(script);
      return function () {
        document.head.removeChild(script);
      };
    }
  }, [token, loadPaymentsSDK]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _PayFabricPaymentsSDKModule.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: PAYFABRIC_PAYMENTS_SDK_ID
  }));
}